import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-visulisation',
  templateUrl: './visulisation.component.html',
  styleUrls: ['./visulisation.component.scss']
})
export class VisulisationComponent implements OnInit {

  constructor() {
    document.getElementsByClassName("menuSelect")[0]['style'].display = "block";
    document.getElementsByClassName("menuTitle")[0]['style'].display = "block";
   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/danfostersmith/Documents/GitHub/crossing-borders/src/app/visulisation/visulisation.component.ts